import { useEffect, useState } from "react";
import { KeyRound, Waypoints, Server, Layers, Globe, ShieldAlert } from "lucide-react";
import { api, apiErrorMessage } from "../lib/api";
import { TID } from "../lib/testIds";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import PageHeader from "../components/layout/PageHeader";
import GatewayApiCard from "../components/gateway/GatewayApiCard";
import GatewayKeyCard from "../components/gateway/GatewayKeyCard";
import GatewayEnginesList from "../components/gateway/GatewayEnginesList";
import GatewayWebTargetsList from "../components/gateway/GatewayWebTargetsList";
import GatewayRoutesList from "../components/gateway/GatewayRoutesList";

export default function GatewayPage() {
  const [status, setStatus] = useState({ ready: null, message: "" });

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/gateway/status");
        setStatus(r.data);
      } catch (e) {
        setStatus({ ready: false, message: apiErrorMessage(e) });
      }
    })();
  }, []);

  return (
    <div data-testid={TID.gateway.root} className="space-y-6">
      <PageHeader
        title="KRAI API Gateway"
        subtitle="Panel administrativo. Aún no envía peticiones reales a motores IA."
      />

      {status.ready === false && (
        <div className="rounded-md border border-amber-900 bg-amber-950/40 p-4 flex items-start gap-3 text-sm">
          <ShieldAlert className="h-4 w-4 text-amber-400 mt-0.5 shrink-0" />
          <div className="text-amber-200">
            <div className="font-medium">Módulo no disponible</div>
            <div className="text-xs text-amber-200/80 mt-1">{status.message}</div>
          </div>
        </div>
      )}

      <Tabs defaultValue="config" className="w-full">
        <TabsList className="bg-zinc-900 border border-zinc-800 flex-wrap h-auto">
          <TabsTrigger data-testid={TID.gateway.tab("config")} value="config" className="gap-2">
            <Server className="h-3.5 w-3.5" /> Mi API
          </TabsTrigger>
          <TabsTrigger data-testid={TID.gateway.tab("keys")} value="keys" className="gap-2">
            <KeyRound className="h-3.5 w-3.5" /> Mi API Key
          </TabsTrigger>
          <TabsTrigger data-testid={TID.gateway.tab("web-targets")} value="web-targets" className="gap-2">
            <Globe className="h-3.5 w-3.5" /> Web Targets
          </TabsTrigger>
          <TabsTrigger data-testid={TID.gateway.tab("engines")} value="engines" className="gap-2">
            <Layers className="h-3.5 w-3.5" /> Motores API <span className="text-[9px] text-zinc-500 ml-1">(legacy)</span>
          </TabsTrigger>
          <TabsTrigger data-testid={TID.gateway.tab("routes")} value="routes" className="gap-2">
            <Waypoints className="h-3.5 w-3.5" /> Enrutamiento
          </TabsTrigger>
        </TabsList>

        <TabsContent value="config" className="mt-4">
          <GatewayApiCard disabled={status.ready === false} />
        </TabsContent>
        <TabsContent value="keys" className="mt-4">
          <GatewayKeyCard disabled={status.ready === false} />
        </TabsContent>
        <TabsContent value="web-targets" className="mt-4">
          <GatewayWebTargetsList disabled={status.ready === false} />
        </TabsContent>
        <TabsContent value="engines" className="mt-4">
          <GatewayEnginesList disabled={status.ready === false} />
        </TabsContent>
        <TabsContent value="routes" className="mt-4">
          <GatewayRoutesList disabled={status.ready === false} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
